import { formatDays } from './types';

/**
 * Owner 2026-10-24 16:15 (pkt 2): one limit per supplier position across all our events. `GET …/room` — what the
 * position still has on the asked days (`max`: the least left over them; null: not known — no cap); `manual`: the days
 * with a quantity typed by hand („zmień dostępność”). `{}`: no such position, or the role does not see the suppliers'
 * quantities (rule 7a).
 */
export type RoomView = { positionId?: string; stock?: number | null; max?: number | null; taken?: number; manual?: Array<{ day: string; quantity: number }> };

/** „dostępne u dostawcy w dniu X: N (wpisane ręcznie)” per typed day. */
export const manualLines = (manual: RoomView['manual']): string[] => (manual ?? []).map((m) => `dostępne u dostawcy w dniu ${formatDays(m.day, m.day)}: ${m.quantity} (wpisane ręcznie)`);

/** The hover of „max N”. */
export function roomTitle(room: RoomView | undefined): string {
  if (!room || room.max === undefined || room.max === null) return 'Tyle sztuk tej pozycji dostawca ma w swoim katalogu („Ilość posiadanych”)';
  const lines = [`Zostało u dostawcy w tych dniach: ${room.max} szt.`];
  if (typeof room.stock === 'number') lines.push(`„Ilość posiadanych”: ${room.stock} szt.${room.taken ? `, już dopożyczone w tych dniach (wszystkie wydarzenia): ${room.taken}` : ''}`);
  return [...lines, ...manualLines(room.manual)].join('\n');
}
